import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e1e85152")

_pushScopeId("data-v-e1e85152")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12 p-md-12" }
const _hoisted_3 = { class: "p-d-flex p-p-2 p-ai-center" }
const _hoisted_4 = { style: {"font-weight":"bold"} }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "bx bx-edit-alt" }, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { style: {"font-weight":"bold"} }
const _hoisted_8 = { class: "p-text-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-book p-mr-2" }, null, -1)
const _hoisted_10 = { class: "p-text-nowrap" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "pi pi-file-o p-mr-2" }, null, -1)
const _hoisted_12 = { class: "p-text-nowrap" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chart-line p-mr-2" }, null, -1)
const _hoisted_14 = { class: "p-text-nowrap" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "pi pi-list p-mr-2" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExperimentTag = _resolveComponent("ExperimentTag")!
  const _component_InlineText = _resolveComponent("InlineText")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_DatasourceMetaDataFull = _resolveComponent("DatasourceMetaDataFull")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_DatasourceSampleData = _resolveComponent("DatasourceSampleData")!
  const _component_DatasourceEDA = _resolveComponent("DatasourceEDA")!
  const _component_RelatedExperiments = _resolveComponent("RelatedExperiments")!
  const _component_TabView = _resolveComponent("TabView")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.canEdit())
          ? (_openBlock(), _createBlock(_component_Inplace, {
              key: 0,
              active: _ctx.activeEditName,
              "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeEditName = $event)),
              onAccept: _ctx.updateCurDatasource,
              onCancel: _ctx.cancelEditDatasourceName,
              onKeyup: _withKeys(_ctx.cancelEditDatasourceName, ["esc"]),
              style: {"width":"90%"},
              class: "p-text-truncate p-text-nowrap"
            }, {
              display: _withId(() => [
                _createVNode(_component_ExperimentTag, { name: 'DATASOURCE' }),
                _withDirectives(_createVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.datasourceDetail?.name), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    _ctx.datasourceDetail?.name,
                    void 0,
                    { top: true }
                  ]
                ]),
                _hoisted_5
              ]),
              content: _withId(() => [
                _createVNode(_component_InlineText, {
                  model: _ctx.newName,
                  "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newName = $event)),
                  onCancel: _ctx.cancelEditDatasourceName,
                  onAccept: _ctx.updateCurDatasource
                }, null, 8, ["model", "onCancel", "onAccept"])
              ]),
              _: 1
            }, 8, ["active", "onAccept", "onCancel", "onKeyup"]))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              _withDirectives(_createVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.datasourceDetail?.name), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.datasourceDetail?.name,
                  void 0,
                  { top: true }
                ]
              ])
            ])),
        (_ctx.canEdit())
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 2,
              type: "Button",
              icon: "pi pi-plus",
              label: _ctx.$matchMedia.desktop ? _ctx.$t('button.experiment') : '',
              disabled: !_ctx.isReadyToCreateExperiment,
              class: "p-ml-auto",
              onClick: _ctx.toggle,
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu"
            }, null, 8, ["label", "disabled", "onClick"])), [
              [
                _directive_tooltip,
                _ctx.$t('datasource.button.experiment.tooltip'),
                void 0,
                { left: true }
              ]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_Menu, {
          id: "overlay_menu",
          ref: "menu",
          model: _ctx.items,
          popup: true
        }, null, 8, ["model"])
      ]),
      _createVNode(_component_TabView, {
        activeIndex: _ctx.activeTabIndex,
        "onUpdate:activeIndex": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTabIndex = $event)),
        onTabChange: _ctx.tabChangeEvent,
        lazy: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.list-files.table.header.overview")), 1)
              ])
            ]),
            default: _withId(() => [
              (_ctx.datasourceDetail)
                ? (_openBlock(), _createBlock(_component_DatasourceMetaDataFull, {
                    key: 0,
                    datasourceDetail: _ctx.datasourceDetail,
                    fileListLength: _ctx.totalFiles,
                    fileListId: _ctx.id,
                    totalSize: _ctx.totalSize,
                    workspaceId: _ctx.workspaceId
                  }, null, 8, ["datasourceDetail", "fileListLength", "fileListId", "totalSize", "workspaceId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.list-files.table.header.sample_data")), 1)
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_DatasourceSampleData, {
                id: _ctx.id,
                schemas: _ctx.datasourceDetail?.schemas,
                workspaceId: _ctx.workspaceId
              }, null, 8, ["id", "schemas", "workspaceId"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.list-files.table.header.metrics")), 1)
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_DatasourceEDA, { id: _ctx.id }, null, 8, ["id"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.experiments.related_experiments")), 1)
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_RelatedExperiments, {
                datasourceId: _ctx.id,
                workspaceId: _ctx.workspaceId
              }, null, 8, ["datasourceId", "workspaceId"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex", "onTabChange"])
    ])
  ]))
})